"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeSimpleSearchResult = exports.normalizeElasticSearchResult = exports.NormalizedSearchResultPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var NormalizedSearchResultPropType = exports.NormalizedSearchResultPropType = _propTypes["default"].exact({
  guideTitle: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string.isRequired,
  index: _propTypes["default"].oneOf(['guides', 'instructions', 'steps']).isRequired,
  instructionTitle: _propTypes["default"].string,
  locale: _propTypes["default"].string.isRequired,
  media: _propTypes["default"].object,
  stepCount: _propTypes["default"].number,
  title: _propTypes["default"].string.isRequired,
  topicTitle: _propTypes["default"].string,
  totalPublishedInstructionsNumber: _propTypes["default"].number
});

/**
 * Maps an Elastic Search result entry to a normalized representation.
 *
 * @param entry - The Elastic Search result entry to normalize.
 * @returns The normalized representation.
 */
var normalizeElasticSearchResult = exports.normalizeElasticSearchResult = function normalizeElasticSearchResult(entry) {
  var id = entry._id,
    _source = entry._source;
  var guideTitle = _source.guideTitle,
    instructionTitle = _source.instructionTitle,
    locale = _source.locale,
    media = _source.media,
    stepCount = _source.stepCount,
    title = _source.title,
    topicTitle = _source.topicTitle,
    totalPublishedInstructionsNumber = _source.totalPublishedInstructionsNumber;
  var index = entry._index.split('_')[1]; // remove schema prefix from index

  return {
    guideTitle: guideTitle,
    id: id,
    index: index,
    instructionTitle: instructionTitle,
    locale: locale,
    media: media,
    stepCount: stepCount,
    title: title,
    topicTitle: topicTitle,
    totalPublishedInstructionsNumber: totalPublishedInstructionsNumber
  };
};

/**
 * Maps a simple search result entry to a normalized representation.
 *
 * @param entry - The simple search result entry to normalize.
 * @param index - The search index the entry is coming from. Could be either
 * `"guides"` or `"instructions"`.
 * @returns The normalized representation.
 */
var normalizeSimpleSearchResult = exports.normalizeSimpleSearchResult = function normalizeSimpleSearchResult(entry, index) {
  var result = {
    id: entry.id,
    index: index,
    locale: entry.locale,
    media: {
      mediaResource: entry.media
    },
    title: entry.title
  };
  if (index === 'guides') {
    result.guideTitle = entry.title;
    result.totalPublishedInstructionsNumber = entry.totalPublishedInstructionsNumber;
  } else if (index === 'instructions') {
    result.guideTitle = entry.parentGuide.title;
    result.instructionTitle = entry.title;
    result.stepCount = entry.stepsNumber;
    result.topicTitle = entry.parentTopic ? entry.parentTopic.title : '-';
  }
  return result;
};
//# sourceMappingURL=search-result-utils.js.map